import { baseRequest } from '.'
import _get from 'lodash/get'

export const getBrands = async params => {
  const res = await baseRequest.get(`brands/`, { params })
  return _get(res, 'data')
}

export const getBrandPixelData = async (eventId, brandId) => {
  const res = await baseRequest.get(`events/${eventId}/organizations/${brandId}/pixels/`)
  return _get(res, 'data.data')
}

export const getBrandRoles = async () => {
  const res = await baseRequest.get('/organizations/associated?roles[]=admin&roles[]=owner')
  return _get(res, 'data.brands_ids')
}

export const getBrandPaymentSetupIntent = async brandId => {
  const res = await baseRequest.get(`/brand/${brandId}/setup-payment-intent`)
  return _get(res, 'data.data')
}

export const confirmAddedCard = async brandId => {
  await baseRequest.post(`brand/${brandId}/setup-payment-intent/set-confirmed`) 
}

export const getBrandCreditCards = async brandId => {
  const res = await baseRequest.get(`/brand/${brandId}/stripe-payment-methods`)
  return _get(res, 'data.data.attributes')
}

export const setDefaultCard = async (brandId, cardId) => {
  const res = await baseRequest.post(`brand/${brandId}/stripe-payment-methods/set-default`, {
    data: {
      attributes: { brandStripePaymentMethodId: cardId }
    }
  })
  return _get(res, 'data.data.attributes')
}

export const deleteCard = async (brandId, cardId) => {
  const res = await baseRequest.delete(`/brand/${brandId}/stripe-payment-methods`, {
    data: {
      data: {
        attributes: { brandStripePaymentMethodId: cardId }
      }
    }
  })
  return _get(res, 'data.data.attributes')
}

export const manageStripeConnectedAccount = async (brandId, code, enableConnectedAccount) => {
  const res = await baseRequest.patch(`/organizations/${brandId}/payment-methods/stripe`, {
    data: {
      code,
      attributes: {
        enableConnectedAccount,
      },
    },
  })
  return res
}

export const sendReferrerLink = async (brandId, values) => {
  const res = await baseRequest.post(`brands/${brandId}/referrals`, values)
  return _get(res, 'data.data')
}

export const listForReferrals = async brandId => {
  const res = await baseRequest.get(`brands/${brandId}/referrals`)
  return _get(res, 'data.data')
}

export const deleteFromReferrals = async (brandId, brandReferralPartnerId) => {
  const res = await baseRequest.delete(`brands/${brandId}/referrals/${brandReferralPartnerId}`)
  return _get(res, 'data.data')
}